import React from 'react';
import DetalhesOperacao from './DetalhesOperacao';
import { Card } from 'antd';

function OperacaoFalhou({ultimoLog}) {

    return (
        <Card title="Status do processamento">
            <DetalhesOperacao ultimoLog={ultimoLog} />
        </Card>
    );
}

export default OperacaoFalhou;